import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { dashboardDataApi } from '../../api';
import KpiGrid from '../dashboard/KpiGrid';
import RevenueChart from '../dashboard/RevenueChart';
import FilterToggle from '../dashboard/FilterToggle';
import CustomCardWithGraph from '../../common/card/CustomCardWithGraph';

const TotalSales = () => {
  const token = useSelector((state) => state?.user?.user?.token);
  const [filter, setFilter] = useState('week');
  const [cardData, setCardData] = useState(null);
  const [graphData, setGraphData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await dashboardDataApi({ token, filter });
        setCardData(response);
        setGraphData(
          (response?.revenueData || []).map((item) => ({
            name: item?.label?.slice(0, 3),
            totalRevenue: item?.totalRevenue,
            totalSales: item?.totalSales,
          }))
        );
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [token, filter]);

  return (
    <Box sx={{ mt: 3 }}>
      {/* Header + filter */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: { xs: 'flex-start', sm: 'center' },
          flexDirection: { xs: 'column', sm: 'row' },
          gap: 2,
          mb: 3,
        }}
      >
        <Typography
          sx={{ fontSize: { xs: '18px', sm: '22px' }, fontWeight: 600, color: '#362B24', fontFamily: 'Heebo' }}
        >
          Total Sales
        </Typography>
        <FilterToggle value={filter} onChange={setFilter} />
      </Box>

      {/* All 6 KPI cards */}
      <KpiGrid data={cardData} loading={loading} />

      {/* Combined overview chart */}
      <RevenueChart data={cardData?.revenueData} loading={loading} title="Revenue Overview" />

      {/* Side-by-side detail bar charts */}
      <Box mb={4} mt={3}>
        <Grid container spacing={{ xs: 2, sm: 2 }}>
          <Grid item xs={12} lg={6}>
            <CustomCardWithGraph
              title="Total Revenue"
              data={graphData}
              dataKey="totalRevenue"
              customStyles={{ minWidth: 0 }}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <CustomCardWithGraph
              title="Total Sales"
              data={graphData}
              dataKey="totalSales"
              customStyles={{ minWidth: 0 }}
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default TotalSales;
